module.exports = __webpack_public_path__ + "img/4D.8f8919d8.png";